import miscMutations from "./mutations.js";
import miscActions from "./actions.js";
import miscGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      previouslySelectedChannelOrUser:{},
      startupData:{channels:[]},
      clickFirstPanel:-1,
      AIPanelInfo:false
    };
  },
  mutations: miscMutations,
  actions: miscActions,
  getters: miscGetters,
};
